const Button = (props) => {
    return (
        <button className={`button ${props.className}`} type={props.type || "button"} title={props.title} disabled={props.disabled} onClick={props.onClick}>
            {props.children}
        </button>
    );
};

export default Button;